/* Copyright 2020 Avetti.com Corporation - All Rights Reserved

This source file is subject to the Avetti Commerce Front End License (ACFEL 1.20)
that is accessible at https://www.avetticommerce.com/license */ import {
  PREVIEW,
  PROJECT_LINK,
} from "../../project-config";

export const footerContent = {
  about: [
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            to: `/furniture/sofas`,
          },
          text: "Sofas",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            to: `/furniture/seating`,
          },
          text: "Seating",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            to: `/furniture/dining`,
          },
          text: "Dining",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            to: `/furniture/beds`,
          },
          text: "Beds",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            to: `/furniture/beds/king-size-beds`,
          },
          text: "Kids Furniture",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            to: `/furniture/seating/chairs/office-chairs`,
          },
          text: "Office Furniture",
        },
      ],
    },
  ],
  shop: [
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer",
            href:
              "https://www.avetticommerce.com/b2b-b2c-multivendor-marketplaces",
          },
          text: "About Us",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer",
            href:
              "https://www.avetticommerce.com/b2b-b2c-multivendor-marketplaces",
          },
          text: "FAQs",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer",
            href:
              "https://www.avetticommerce.com/b2b-b2c-multivendor-marketplaces",
          },
          text: "Contact Us",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer",
            href:
              "https://www.avetticommerce.com/b2b-b2c-multivendor-marketplaces",
          },
          text: "Blog",
        },
      ],
    },
  ],
  policies: [
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer",
            href:
              "https://www.avetticommerce.com/b2b-b2c-multivendor-marketplaces",
          },
          text: "Terms of Use",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer",
            href: "https://www.avetticommerce.com/multi-store-ecommerce",
          },
          text: "Privacy Policy",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer",
            href:
              "https://www.avetticommerce.com/b2b-b2c-multivendor-marketplaces",
          },
          text: "Terms Of Sale",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer",
            href:
              "https://www.avetticommerce.com/b2b-b2c-multivendor-marketplaces",
          },
          text: "Shipping Policy",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            target: "_blank",
            href:
              "https://www.avetticommerce.com/b2b-b2c-multivendor-marketplaces",
          },
          text: "Register a Complaint",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            target: "_blank",
            href:
              "https://www.avetticommerce.com/b2b-b2c-multivendor-marketplaces",
          },
          text: "Payment and Security",
        },
      ],
    },
  ],
  network: [
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            to: `/login`,
          },
          text: "Helpcenter",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            to: `/login`,
          },
          text: "Terms",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer",
            href: "https://www.avetticommerce.com/privacy-policy",
          },
          text: "Cookies",
        },
      ],
    },
    {
      parent: { attributes: {} },
      children: [
        {
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer",
            href: "https://www.avetticommerce.com/privacy-policy",
          },
          text: "Privacy policy",
        },
      ],
    },
  ],
};
